import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

let routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
	},
	{
		path: '/about',
		name: 'about',
		component: () => import('../pages/about.vue'),
	},
	{
		path: '/privacy-policy',
		name: 'privacy',
		component: () => import('../pages/privacy.vue'),
	},
	{
		path: '/terms-of-services',
		name: 'terms',
		component: () => import('../pages/terms.vue'),
	},
	{
		path: '/disclaimer',
		name: 'disclaimer',
		component: () => import('../pages/disclaimer.vue'),
	},
	{
		path: '/car-list',
		name: 'all',
		component: () => import(/* webpackChunkName: "all" */ '../pages/all'),
	},
	{
		path: '/car-rank',
		name: 'rankings',
		component: () => import(/* webpackChunkName: "rankings" */ '../pages/rankings'),
	},
	{
		path: '/cars/:carName/:id',
		name: 'detail',
		component: () => import(/* webpackChunkName: "detail" */ '../pages/detail.vue'),
		props: true,
	},
	{
		path: '/:channel(channel[1-9]\\d?)/cars/:carName/:id',
		name: 'channelDetail',
		component: () => import(/* webpackChunkName: "detail" */ '../pages/detail.vue'),
		props: true,
	},
	{
		path: '/:channel(channel[1-9]\\d?)/car-rank',
		name: 'channelRankings',
		component: () => import(/* webpackChunkName: "rankings" */ '../pages/rankings.vue'),
		props: true,
	},
	{
		path: '/:channel(channel[1-9]\\d?)/car-list',
		name: 'channelAll',
		component: () => import(/* webpackChunkName: "all" */ '../pages/all.vue'),
		props: true,
	},

	{
		path: '/:channel(channel[1-9]\\d?)/about',
		name: 'channelabout',
		component: () => import('../pages/about.vue'),
	},
	{
		path: '/:channel(channel[1-9]\\d?)/privacy-policy',
		name: 'channelprivacy',
		component: () => import('../pages/privacy.vue'),
	},
	{
		path: '/:channel(channel[1-9]\\d?)/terms-of-services',
		name: 'channelterms',
		component: () => import('../pages/terms.vue'),
	},
	{
		path: '/:channel(channel[1-9]\\d?)/disclaimer',
		name: 'channeldisclaimer',
		component: () => import('../pages/disclaimer.vue'),
	},
	{
		path: '/:channel(channel[1-9]\\d?)',
		name: 'homechannel',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
		props: true,
		beforeEnter: (to, from, next) => {
			console.log(`访问的是 /${to.params.channel}`)
			next()
		},
	},
	// 最后放置通配路由
	{
		path: '*',
		redirect: { name: 'home' },
	},
]

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
